module.exports = __webpack_public_path__ + "img/overview-five.bb3a0ae7.png";